/* eslint-disable react/no-unknown-property */
import { Button, Figure as HedwigFigure } from "@postenbring/hedwig-react";
import { PlayIcon } from "./play-icon";
import "./figure.scss";

export const Figure = ({
  imageUrl,
  imageAltText,
  mobileImageUrl,
  mobileImageAltText,
  caption,
  video,
}) => (
  <>
    {video ? (
      <div className="kp-figure-video hds-mb-20-24">
        <div className={video.containerClass}>
          <HedwigFigure>
            <div id={`${video.id}_${video.uuid}_img`} video-src={video.src} className="img-overlay">
              <div className="img-overlay-background">
                <Button
                  className="play-button"
                  size="large"
                  aria-label={video.videoButtonAriaLabel}
                >
                  <PlayIcon />
                </Button>
              </div>
              {video.imageOverlayUrl && (
                <img
                  src={video.imageOverlayUrl}
                  alt={video.imageAltText || imageAltText || ""}
                  loading="lazy"
                />
              )}
            </div>
          </HedwigFigure>
        </div>
      </div>
    ) : (
      <HedwigFigure className="hds-mb-20-24">
        <img
          src={imageUrl}
          alt={imageAltText}
          className={mobileImageUrl !== "" ? "hidden-before-medium" : ""}
        />
        {mobileImageUrl && (
          <img src={mobileImageUrl} alt={mobileImageAltText} className="hidden-after-medium" />
        )}
        {caption && <figcaption>{caption}</figcaption>}
      </HedwigFigure>
    )}
  </>
);
